export default __webpack_public_path__ + "static/media/extra-strength.7cc61f14.png";